import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { joinByInvite, previewInvite } from '../api/chats';
import type { InvitePreview } from '../api/chats';
import { ApiError } from '../api/client';
import { backdropClose } from '../lib/modalBackdrop';

interface Props {
  token: string;
  onClose: () => void;
  /** Вступили (или уже были в группе) — открыть чат. */
  onJoined: (chatId: string) => void;
}

/** Окно вступления по ссылке `/join/<token>`: что за группа → «Вступить». */
export default function JoinInviteModal({ token, onClose, onJoined }: Props) {
  const { t } = useTranslation('misc');
  const [preview, setPreview] = useState<InvitePreview | null>(null);
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    previewInvite(token)
      .then(setPreview)
      .catch((e) => setError(e instanceof ApiError && e.status === 404
        ? t('joinInvalidLink')
        : t('joinPreviewFailed')));
  }, [token, t]);

  const join = async () => {
    if (busy) return;
    setBusy(true);
    try {
      onJoined((await joinByInvite(token)).chatId);
    } catch (e) {
      setError(e instanceof ApiError ? e.message : t('joinFailed'));
      setBusy(false);
    }
  };

  return (
    <div className="modal-backdrop" {...backdropClose(onClose)}>
      <div className="modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 380 }}>
        <button type="button" className="modal-close" title={t('joinClose')} onClick={onClose}>✕</button>
        <h2>{t('joinTitle')}</h2>
        {error && <div className="error" style={{ marginBottom: 12 }}>{error}</div>}
        {preview && (
          <>
            <div style={{ fontSize: 18, margin: '8px 0 4px' }}>{preview.title}</div>
            <div style={{ color: 'var(--muted)', fontSize: 13, marginBottom: 16 }}>{t('joinMembers', { count: preview.memberCount })}</div>
            <div className="row" style={{ justifyContent: 'space-between' }}>
              <a className="btn btn-ghost" href={`homechat://join?t=${encodeURIComponent(token)}`}>{t('joinOpenApp')}</a>
              <button className="btn" onClick={join} disabled={busy}>
                {preview.alreadyMember ? t('joinOpenChat') : t('joinAction')}
              </button>
            </div>
          </>
        )}
        {!preview && !error && <span className="spinner" />}
      </div>
    </div>
  );
}
